<style>
  svg {
    fill: #000;
    height: 90%;
    margin-left: 5%;
    margin-top: 5%;
  }
</style>

<svg
  xmlns="http://www.w3.org/2000/svg"
  xmlns:xlink="http://www.w3.org/1999/xlink"
  viewBox="0 0 24.06 24.15">
  <path
    d="M12,3l7,7H13.24V21.23H10.76V10H5ZM8.82.43A12.4,12.4,0,0,0,6,1.65,11.94,11.94,0,0,0,3.52,3.54,11.43,11.43,0,0,0,1.64,6,12.37,12.37,0,0,0,.43,8.85,11.64,11.64,0,0,0,0,12a12.05,12.05,0,0,0,.42,3.2,13,13,0,0,0,1.2,2.9,12.71,12.71,0,0,0,1.87,2.45A12.11,12.11,0,0,0,5.92,22.5a12.4,12.4,0,0,0,2.87,1.22,12.23,12.23,0,0,0,6.43,0,12.36,12.36,0,0,0,2.89-1.22,12.11,12.11,0,0,0,2.43-1.91,12.37,12.37,0,0,0,1.88-2.45A12.21,12.21,0,0,0,24.06,12a11.65,11.65,0,0,0-.44-3.19A12.37,12.37,0,0,0,22.41,6a12.16,12.16,0,0,0-1.89-2.44,12,12,0,0,0-2.44-1.89A12.47,12.47,0,0,0,15.2.43,11.77,11.77,0,0,0,12,0,11.57,11.57,0,0,0,8.82.43"
    transform="translate(0 0)" />
</svg>
